import {
    AfterViewInit,
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
} from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Subject, throwError } from "rxjs";
import { catchError, finalize, takeUntil } from "rxjs/operators";
import { SStatsCardEmployeeCourseService } from "./s-stats-card-employee-course.service";
import { EmployeeCourseFilterInput, TotalizerEmployeeCourseChangeDto } from "../../core/interfaces/employee-course-input";
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: "s-stats-card-employee-course",
    templateUrl: "./s-stats-card-employee-course.component.html",
    styleUrls: ["./s-stats-card-employee-course.component.scss"]
})
export class SStatsCardEmployeeCourseComponent implements AfterViewInit, OnDestroy {

    @Input() domain: string;
    @Input() service: string;
    @Input() employeeSearch: string;
    @Output() totalizerChangeEvent = new EventEmitter<TotalizerEmployeeCourseChangeDto>();

    totalizerCountLoading = true;
    totalizerCountError = false;

    private readonly _filter: EmployeeCourseFilterInput = {};
    private readonly _ngUnsubscribe = new Subject();
    private _totalCourseHoursCount: string | number;
    private _participationRate: string;
    private _enrollmentRate: string;
    private _effectiveness: string;

    constructor(
        private readonly _translateService: TranslateService,
        private readonly route: ActivatedRoute,
        private readonly _sStatsCardEmployeeCourseService: SStatsCardEmployeeCourseService
    ) {}

    ngOnDestroy(): void {
        this._ngUnsubscribe.next();
        this._ngUnsubscribe.complete();
    }

    @Input()
    public set ticket(ticket) {
        this._filter.ticket = ticket;
        if (ticket && this.domain && this.service) {
            this.updateCounters();
        }
    }
    ngAfterViewInit() {
        if (!this._filter?.ticket) {
            this.updateCounters();
        }
    }
    private genericGet(value: string | number): string {
        if (typeof value === 'string') {
            return value;
        }
        return value && value >= 1 ? value.toString() : '0';
    }

    getFormattedDataRate(dataRate: string): string {
        if (this.containsLetters(dataRate)) {
            if (dataRate === null || dataRate === undefined || dataRate === '') {
                return '0,00%';
            }
            return dataRate;
        }

        dataRate = this.ensureTwoDecimalPlaces(dataRate);

        return `${dataRate}%`;
    }

    private containsLetters(dataRate: string): boolean {
        const regex = /[A-Za-z]/;
        return regex.test(dataRate);
    }

    private ensureTwoDecimalPlaces(dataRate: string): string {
        if (dataRate === null || dataRate === undefined || dataRate === '') {
            return '0,00';
        }
        const decimalRegex = /,(\d+)/;
        const match = decimalRegex.exec(dataRate);
        if (match) {
            const decimalPart = match[1];
            if (decimalPart.length > 2) {
                const parts = dataRate.split(',');
                return `${parts[0]},${parts[1].substring(0, 2)}`;
            } else if (decimalPart.length === 1) {
                return `${dataRate}0`;
            } else {
                return dataRate;
            }
        } else {
            return `${dataRate},00`;
        }
    }

    private setFields() {
        this._filter.domain = this.domain;
        this._filter.service = this.getService();
        this._filter.employeeSearch = this.employeeSearch;
    }

    public updateCounters() {
        this.totalizerCountLoading = true;
        const messageError = this._translateService.instant('hcm.analytics_sst.error_fetching_count');
        this.setFields();
        this._sStatsCardEmployeeCourseService.totalizerEmployeeCourseCardsCount(this._filter)
            .pipe(
                takeUntil(this._ngUnsubscribe),
                finalize(() => {
                    const totalizerChangeDto: TotalizerEmployeeCourseChangeDto = {
                        totalCourseHoursCount: this.totalCourseHoursCount,
                        participationRate: this.participationRateCount,
                        enrollmentRate: this.enrollmentRateCount,
                        effectiveness: this.effectivenessCount
                    }
                    this.totalizerChangeEvent.next(totalizerChangeDto);
                })
            )
            .pipe(catchError((error) => {
                this.totalCourseHoursCount = messageError,
                this.participationRateCount = messageError,
                this.enrollmentRateCount = messageError,
                this.effectivenessCount = messageError,
                this.totalizerCountLoading = false;
                this.totalizerCountError = true;
                return throwError(error);
            }))
            .subscribe((response: any) => {
                this.totalCourseHoursCount = response.result.totalCourseHoursCount;
                this.participationRateCount = response.result.participationRate;
                this.enrollmentRateCount = response.result.enrollmentRate;
                this.effectivenessCount = response.result.effectiveness;

                this.totalizerCountError = false;
                this.totalizerCountLoading = false;
            });

    }
    get totalCourseHoursCount(): string | number {
        return this.genericGet(this._totalCourseHoursCount);
    }

    set totalCourseHoursCount(value: string | number) {
        this._totalCourseHoursCount = value;
    }

    get participationRateCount(): string {
        return this._participationRate;
    }

    set participationRateCount(value: string) {
        this._participationRate = value;
    }

    get enrollmentRateCount(): string {
        return this._enrollmentRate;
    }

    set enrollmentRateCount(value: string) {
        this._enrollmentRate = value;
    }

    get effectivenessCount(): string {
        return this._effectiveness;
    }

    set effectivenessCount(value: string) {
        this._effectiveness = value;
    }

    /**
     * Esse funÃ§Ã£o foi criada pra chavear o contexto do filtro avanÃ§ado.
     * Quando vier do analytics-frontend, deve passar o serviÃ§o analytics, quando abrir direto na tela
     * do analytics-sst, deve passar o serviÃ§o do analytics_sst
     * o parametro "ticket" sÃ³ vai vir na rota, atrÃ¡ves do analytics-frontend
     * @private
     */
    private getService() {
        let service = this.service;
        if (this.route?.snapshot?.queryParams["ticket"]) {
            service = "analytics";
        }
        return service;
    }
}
